import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMagnifyingGlass, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { WorkflowElementType } from '../../../models/Enums/workflow-element-type';
import { WorkflowValidityReport } from '../../../models/workflow-validity-report';

@Component({
    selector: 'app-workflow-validity-report-viewer-component',
    imports: [FontAwesomeModule],
    templateUrl: './workflow-validity-report-viewer-component.component.html',
    styleUrl: './workflow-validity-report-viewer-component.component.scss'
})
export class WorkflowValidityReportViewerComponentComponent {
    public gotoIcon = faMagnifyingGlass;
    public errorIcon = faTriangleExclamation;
    public warningIcon = faTriangleExclamation;

    @Input()
    data: { data: WorkflowValidityReport; type: 'Errors' | 'Warnings' };

    @Output()
    validityElementClick = new EventEmitter<{ elementType: WorkflowElementType; elementId: number }>();

    public goto(sourceType: WorkflowElementType, sourceId: number) {
        console.log(`Go to element ${sourceId} of tye ${sourceType}`);
        this.validityElementClick.emit({ elementType: sourceType, elementId: sourceId });
    }
}
